import { render, staticRenderFns } from "./DeleteCashReceipts.vue?vue&type=template&id=791c8f52&scoped=true"
import script from "./DeleteCashReceipts.vue?vue&type=script&lang=js"
export * from "./DeleteCashReceipts.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "791c8f52",
  null
  
)

export default component.exports